export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f78dda3912060c9be9d7b0cd5c4fb63eb6b7760fc&name=fetchTypeahead!'